import { gql } from 'graphql-request';
import { createMemo, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { BlogNewsListCardData, BlogNewsListDataContainer } from '../blog-news/blog-news';
import { BlogsNewsProps } from './blogs-news';
import { mapBlogMetaToListCardData } from './map-blog-meta-to-list-card-data';

const GET_POSTS_QUERY = gql`
    query GetPosts(
        $tags: [String]
        $limit: Int
    ) {
        posts: resources(
            type: "blog-and-news"
            tags: $tags
            limit: $limit
            order: DESC
        ) {
            key
            meta {
                postTitle
                categories
                description
                featuredImage
                extra
            }
        }
    }
`;

export const fetchBlogsAndNews = (props: BlogsNewsProps) => {
    const { createCachedResource, blogAndNewsEntityName } = useContext(AppContext);

    const POST_QUERY_VARS = {
        ...props?.tag?.slug
            ? { tags: [props?.tag?.slug] }
            : null,
        ...props?.limit
            ? { limit: props?.limit }
            : null,
    };

    try {
        const [postsContent] = createCachedResource(GET_POSTS_QUERY, POST_QUERY_VARS, true);
    
        return createMemo((): BlogNewsListCardData[] => postsContent()?.posts
            ?.filter((post: BlogNewsListDataContainer) => {
                return !post?.meta?.extra?.hideOnWeb;
            })
            .map((post: BlogNewsListDataContainer) => {
                return mapBlogMetaToListCardData(post, blogAndNewsEntityName);
            })
            .sort((a: BlogNewsListCardData, b: BlogNewsListCardData) => {
                // Newest show first TODO: does this work?
                // AS: yes it does work, why not?
                const dateA = a.date ? new Date(a.date).getTime() : 0; // Use 0 as default if a.date is undefined
                const dateB = b.date ? new Date(b.date).getTime() : 0; // Use 0 as default if b.date is undefined
                return dateB - dateA; // Reverse order to show newest first
            }));
    } catch (err) {
        console.log('Error fetching blogs and news: ', err);
        throw err;        
    }
    
};
